import { Component, EventEmitter, Input, Output } from '@angular/core';
import { VideoRowAccess } from '../video-detail-access';
import { ageBadge, showCount } from '../video-detail-format';
import { PLAY_STATE_LABELS, PlayState } from '../video-detail-inline';

/** One video in the album list. Presentation only: every action is emitted to the page. */
@Component({
  selector: 'app-vd-video-row',
  templateUrl: './vd-video-row.component.html',
})
export class VdVideoRowComponent {
  @Input() element: any = {};
  @Input() index = 0;
  @Input() access: VideoRowAccess;
  @Input() fallbackImage = '';
  @Input() settingsData: any = {};
  @Input() playListAry: any[] = [];
  /** The album's tickets: a track sold on its own shows its price on Buy. */
  @Input() tickets: any[] = [];
  @Input() isPreview = false;
  /** Side-panel layout: thumbnail + title on one line, actions below. */
  @Input() compact = false;
  /** This video is in the inline player. */
  @Input() playing = false;
  /** What the player is doing with this video when `playing`; after it ends, Play shows again. */
  @Input() playState: PlayState = 'playing';
  /** Play was clicked on this video and the player is being prepared. */
  @Input() starting = false;
  /** The video that plays after the current one. */
  @Input() next = false;

  @Output() play = new EventEmitter<any>();
  /** Pause / resume the video in the player. */
  @Output() togglePlay = new EventEmitter<void>();
  @Output() buy = new EventEmitter<any>();
  @Output() subscribe = new EventEmitter<any>();
  @Output() like = new EventEmitter<{ element: any; index: number }>();
  /** `anchor` is the share button: the share panel opens next to it. */
  @Output() share = new EventEmitter<{ element: any; anchor: HTMLElement }>();
  @Output() report = new EventEmitter<any>();
  @Output() createPlaylist = new EventEmitter<void>();
  @Output() addToPlaylist = new EventEmitter<{ element: any; playList: any }>();

  readonly showCount = showCount;

  get info(): any {
    return this.element?.stream_info || {};
  }

  get badge(): string | null {
    return ageBadge(this.info.ageInfo);
  }

  /** In the player and not finished: Play is hidden. */
  get inPlayer(): boolean {
    return this.playing && this.playState !== 'ended';
  }

  get stateLabel(): string {
    return PLAY_STATE_LABELS[this.playState];
  }

  get toggleLabel(): string {
    return this.playState === 'playing' ? 'Pause' : 'Resume';
  }

  get liked(): boolean {
    return this.info.is_liked == 1;
  }

  onThumbnail(): void {
    if (this.access?.canPlay && this.inPlayer && this.playState !== 'loading') {
      this.togglePlay.emit();
      return;
    }
    if (this.access?.canPlay && !this.access.saleNotStarted && !this.inPlayer && !this.starting) {
      this.play.emit(this.element);
    }
  }
}
